export default __webpack_public_path__ + "static/media/Me3_2ndEdition-128s.d57c6ac8.gif";